import React from "react";
import { QUERY_INVOICE_ARRIVALS } from "../../../../utils";
import { useLoadMoreList } from "../../../../../../utilities/load-more-list";
import {
  InvoiceArrival,
  InvoiceArrivalStatus,
} from "@towersystems/roam-common/lib/generated-types";
import { useScheduler } from "../../../../../../utilities/scheduler";
import { useSearchQueryProvider } from "../../../../../../utilities/search";
import { FlatListSearchableSkeleton } from "../../../../../../components/FlatListSearchableSkeleton";
import { InvoiceArrivalResourceList } from "../../../../components";
import { useFocusEffect } from "@react-navigation/native";
import { InvoiceArrivalFilterValues } from "../../../../types";
import { useListFilterContext } from "../../../../../../utilities/list-filter/use-list-filter-context";
import { filterValuesToApiInput } from "../../../../common";

export interface OtherInvoiceArrivalsTabViewProps {}

export const OtherInvoiceArrivalsTabView =
  ({}: OtherInvoiceArrivalsTabViewProps) => {
    const search = useSearchQueryProvider();
    const { schedule } = useScheduler(500);

    const { watch } = useListFilterContext<InvoiceArrivalFilterValues>();
    const watchedFilterValues = watch();

    const loadMoreList = useLoadMoreList<InvoiceArrival>({
      initialLoad: false,
      query: QUERY_INVOICE_ARRIVALS,
      resultKey: "invoiceArrivals",
      sort: { updatedAt: "DESC" },
      variableFormatter: (variables) => {
        return {
          options: {
            ...variables,
            filter: {
              ...variables.filter,
              status: { notEq: InvoiceArrivalStatus.PENDING },
            },
          },
        };
      },
    });

    useFocusEffect(
      React.useCallback(() => {
        handleLoadMore(true);
      }, [watchedFilterValues])
    );

    React.useEffect(() => {
      if (loadMoreList.called) {
        schedule(() => {
          handleLoadMore(true);
        });
      }
    }, [search.query]);

    const handleLoadMore = (reset?: boolean) => {
      loadMoreList.loadMore(
        {
          filter: {
            invoiceNumber: { contains: search.query },
            ...filterValuesToApiInput(watchedFilterValues),
          },
        },
        reset
      );
    };

    const items: InvoiceArrival[] = loadMoreList.items || [];

    if (loadMoreList.loading && loadMoreList.items.length == 0) {
      return <FlatListSearchableSkeleton searchbar={false} />;
    }

    return (
      <InvoiceArrivalResourceList
        items={items}
        onEndReached={() => handleLoadMore(false)}
      />
    );
  };
